import { render, staticRenderFns } from "./register-request-to-reviewers.vue?vue&type=template&id=8eb512fa&lang=pug&"
import script from "./register-request-to-reviewers.vue?vue&type=script&lang=ts&"
export * from "./register-request-to-reviewers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports